import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';

const CountyLink = (props) => {
  const title = props.title;
  return (
    <a {...props} target="_blank" rel="noreferrer" className="p-1 text-white text-decoration-none">
      {title}
    </a>
  );
};

const Footer = () => {
  return (
    <div className="mt-auto">
      <footer className="bg-dark bg-gradient text-white d-flex justify-content-around py-5 my-4">
        <div className="d-flex flex-column">
          <h5>Finance, Internal Audit</h5>
          <p>
            <h6>Address:</h6>
            100 E Center Street Suite 3600 Provo, Utah 84606
          </p>
          <p>
            <h6>Phone:</h6>
            801-851-8109
          </p>
          <h6>Email Addresses:</h6>
          <p className="mb-1">
            General Email:{' '}
            <Link
              to={{ pathname: 'mailto:auditor@UtahCounty.gov' }}
              target="_blank"
              className="text-white fw-bold text-decoration-none mb-1"
            >
              Auditor@UtahCounty.gov
            </Link>
          </p>
          <p className="mb-1">
            Board of Equalization:{' '}
            <Link
              to={{ pathname: 'mailto:boe@utahcounty.gov' }}
              target="_blank"
              className="text-white fw-bold text-decoration-none mb-1"
            >
              Boe@utahcounty.gov
            </Link>
          </p>
          <p className="mb-1">
            Budget & Finance:{' '}
            <Link
              to={{ pathname: 'Auditor@UtahCounty.gov' }}
              target="_blank"
              className="text-white fw-bold text-decoration-none mb-1"
            >
              Auditor@UtahCounty.gov
            </Link>
          </p>
          <p className="mb-1">
            Purchasing:{' '}
            <Link
              to={{ pathname: 'mailto:RobertB@utahcounty.gov' }}
              target="_blank"
              className="text-white fw-bold text-decoration-none"
            >
              RobertB@utahcounty.gov
            </Link>
          </p>
        </div>
        <div>
          <h5>Popular Links</h5>
          <div className="d-flex flex-column">
            <CountyLink
              href="https://www.utahcounty.gov/Dept/ClerkAud/TaxAdmin/index.asp"
              title="May Tax Sale"
            />
            <CountyLink
              href="https://www.utahcounty.gov/Dept/ClerkAud/TaxAdmin/Equalization/index.asp"
              title="Valuation and Taxes"
            />
            <CountyLink
              href="https://www.utahcounty.gov/Dept/ClerkAud/BudgetFinance/FinancialReports.asp"
              title="Financial Reports"
            />
            <h5>Other Websites</h5>
            <CountyLink
              href="https://propertytax.utah.gov/"
              title="Utah State Tax Commission-Property Tax Division"
            />
            <CountyLink
              href="https://taxrates.utah.gov/Login.aspx"
              title="State of Utah Tax Rates"
            />
            <CountyLink
              href="https://mycash.utah.gov/"
              title="State of Utah Unclaimed Property Office"
            />
            <CountyLink
              href="https://www.utah.gov/transparency/"
              title="Utah Public Finance Transparancy"
            />
            <CountyLink
              href="https://utahcounty.wd1.myworkdayjobs.com/Utah_County_Careers"
              title="Utah County Employment Opportunities"
            />
          </div>
        </div>
        <div>
          <h5>Codes & Ordinances</h5>
          <div className="d-flex flex-column">
            <CountyLink
              href="https://www.utahcounty.gov/ordinances/index.asp"
              title="Utah County Code"
            />
            <CountyLink
              href="https://www.utahcounty.gov/Dept/ComDev/LinkCat.asp?Abbv=LUO"
              title="Utah County Land Use Ordinance"
            />
            <CountyLink
              href="https://le.utah.gov/Documents/code_const.htm"
              title="Utah State Code"
            />
            <CountyLink href="https://le.utah.gov/" title="Utah State Legislature" />
          </div>
        </div>
      </footer>

      {/* Fixed Footer */}
      <Navbar
        bg="light"
        variant="light"
        expand="md"
        className="pt-0 d-flex justify-content-around flex-column"
        fixed="bottom"
      >
        <Navbar.Brand className="fs-6">
          Copyright &copy; 2022 Utah County Government | All Rights Reserved
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav.Item as={Link} to="/" className="text-decoration-none px-2 fw-lighter">
            Terms and Conditions
          </Nav.Item>
          <Nav.Item as={Link} to="/" className="text-decoration-none px-2 fw-lighter">
            Webmaster
          </Nav.Item>
          <Nav.Item as={Link} to="/" className="text-decoration-none px-2 fw-lighter">
            Online Services
          </Nav.Item>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default Footer;
